export enum CustomerExperienceReservoir {
  BIBLIOTECA_GENERAL = 'EXP_CLIENTE_BIBLIOTECA',
  MANUAL = 'EXP_CLIENTE_MANUAL',
  RESENAS_GOOGLE = 'EXP_CLIENTE_RG_BIBLIOTECA',
  DOCUMENTOS = 'EXP_CLIENTE_DOCUMENTOS',
  DOCUMENTOS_CATEGORIAS = 'EXP_CLIENTE_DOCUMENTOS_CATEGORIAS',
}
